'use client';
import { createTheme } from '@mui/material/styles';
import { CssVariables } from './constants/theme';

const customCssVariables = {
  [CssVariables.maxWidth]: `${1120 + 2 * 24}px`,
  [CssVariables.mobilePadding]: '24px',
  [CssVariables.desktopPadding]: '24px',
};

const theme = createTheme({
  cssVariables: customCssVariables,
  typography: {
    fontFamily: 'inherit',
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        ':root': {
          ...customCssVariables,
        },
      },
    },
    MuiContainer: {
      styleOverrides: {},
      defaultProps: {
        maxWidth: 'xl',
      },
    },
  },
});

export default theme;
